import { render, staticRenderFns } from "./AppTextDropdown.vue?vue&type=template&id=f3471be8&scoped=true"
import script from "./AppTextDropdown.vue?vue&type=script&lang=js"
export * from "./AppTextDropdown.vue?vue&type=script&lang=js"
import style0 from "./AppTextDropdown.vue?vue&type=style&index=0&id=f3471be8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3471be8",
  null
  
)

export default component.exports